import {
  alias, params, string, extend, arrayOf, shape, bool, customType
} from '@thd-nucleus/data-sources';
import { IntegratedBrandBathPod } from './IntegratedBrandBathPod';

const productModel = extend({}, {
  itemId: string(),
  dataSource: string(),
}, IntegratedBrandBathPod.dataModel.product);

export const wrappedProduct1 = shape({
  category: string(),
  product: shape(productModel)
});
export const dynamicRecsDataModel = extend({
  mimrecs:
    alias('recs').params({
      anchorId: string().isRequired(),
      apiName: string().isRequired(),
      storeId: string(),
      appId: string(),
      key: string(),
      maxResults: string(),
    }).shape({
      metadata: shape({
        collectionTitle2: string(),
        collectionPlpUrl: string()
      }),
      categories: arrayOf(shape({
        category: string(),
        itemIds: arrayOf(string()),
        categoryGuid: string()
      })),
      products: arrayOf(wrappedProduct1)
    })
});
